// import { cookies } from '../cookies'
import { useCallback, useEffect } from 'react'
import type { CookieChangeListener } from 'universal-cookie'

import { initCookies } from '../initCookies'

// value is string because cookies.onChangeListener doesn't auto-parse value like cookies.get does
// https://github.com/reactivestack/cookies/issues/302
export const useCookieChange = (
  cookieName: string,
  onChangeCookie: (value: string) => void
) => {
  const cookies = initCookies()

  const onChange = useCallback<CookieChangeListener>(
    ({ name, value }: { readonly name: string; readonly value?: string }) => {
      name === cookieName && onChangeCookie(value || '')
    },
    [cookieName, onChangeCookie]
  )

  useEffect(() => {
    cookies?.addChangeListener(onChange)
    return () => {
      cookies?.removeChangeListener(onChange)
    }
  }, [cookies, onChange])

  return { onChange }
}
